import axios from "axios";
import store from "./store";
import Vue from "vue";
import qs from "qs";
import router from "./router";
import { l } from "@/assets/js/i18n.js";


const instance = axios.create({
  baseURL: store.state.appConfig.baseURL,
  timeout: 30000,
  headers: { "Content-Type": "application/json" },
});

let requestCount = 0;

instance.interceptors.request.use(
  function (config) {
    requestCount++;
    if (config.showLoading !== false) {
      store.commit("showLoading");
    }
    config.params = { ...config.params, timestamp: Date.now() };//用于阻止IE11的ajax缓存问题

    if (!config.noCancel) {
      config.cancelToken = new axios.CancelToken((cancel) => {
        store.commit("addAxiosPromiseCancel", cancel);
      });
    }

    if (store.state.session.token) {//设置token
      config.headers["Access-Token"] = store.state.session.token;
    }

    if (config.method === "get" || config.method === "delete") {
      //如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      };
    }
    return config;
  },
  function (error) {
    console.log("instanceError", error);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    if (response.status == 258) {//系统维护中
      store.commit("clearAxiosPromiseCancel");
      store.state.axiosPromiseCancelArr.forEach((item) => {
        item && item(l("已取消"));
      });
      store.commit("hideLoading");
      store.commit("clearAxiosPromiseCancel");
      // console.log("response", response);

      Vue.prototype.$alert(response.data.detail, '', {
        confirmButtonText: l('重新加载'),
        showClose: false,
      }).then(() => {
        window.location.reload();
      });

      return;
    }
    if (--requestCount <= 0) {
      store.commit("hideLoading");
      store.commit("clearAxiosPromiseCancel");
    }
    response.data.detail && Vue.prototype.$message.success(l(response.data.detail));
    return response.data.data;
  },
  function (error) {
    if (--requestCount <= 0) store.commit("hideLoading");
    if (axios.isCancel(error)) {
      console.log("Request canceled", error.message);
    } else if (error.response) {
      if (error.response.status == 401) {
        console.log(401);
        store.state.axiosPromiseCancelArr.forEach((item) => {
          item && item(l("已取消"));
        });
        store.commit("clearAxiosPromiseCancel");
        store.commit("logout");
      } else if (error.response.status == 403) {//没权限（引导认证）
        router.push("/backend/dashboard");
        // Vue.prototype.$alert(error.response.data.detail || error.response.status, "请求出错");
      }
      else if (error.response.status == 507) {
        // 会员相关逻辑
        // Vue.prototype.$confirm(l('开通会员解锁更多权益'), l('体验次数已耗尽'), {
        //   confirmButtonText: l('成为会员'),
        //   cancelButtonText: l('取消'),
        //   type: 'warning'
        // }).then(() => {
        // });
      }
      // Vue.prototype.$message.error(error.response.data.detail || "请求出错");
      Vue.prototype.$message({
        message: error.response.data.detail || l("请求出错"),
        type: 'error',
        duration: 5000,
        showClose: true
      });
    } else if (error.request) {
      Vue.prototype.$message.error(l("请求发起失败"));
    } else {
      Vue.prototype.$message.error(l("未知错误"));
      console.log("Error", error.message);
    }

    return Promise.reject(error);
  }
);

export default instance;
